import { css } from "@emotion/react";

export default css`
  @font-face {
    font-family: "Spoqa Han Sans Neo";
    font-weight: 700;
    font-display: swap;
    src: local("Spoqa Han Sans Neo Medium"),
      url("/fonts/SpoqaHanSansNeo/SpoqaHanSansNeo-Medium.woff2") format("woff2"),
      url("/fonts/SpoqaHanSansNeo/SpoqaHanSansNeo-Medium.woff") format("woff"),
      url("/fonts/SpoqaHanSansNeo/SpoqaHanSansNeo-Medium.ttf")
        format("truetype");
  }

  @font-face {
    font-family: "Spoqa Han Sans Neo";
    font-weight: 500;
    font-display: swap;
    src: local("Spoqa Han Sans Neo Medium"),
      url("/fonts/SpoqaHanSansNeo/SpoqaHanSansNeo-Medium.woff2") format("woff2"),
      url("/fonts/SpoqaHanSansNeo/SpoqaHanSansNeo-Medium.woff") format("woff"),
      url("/fonts/SpoqaHanSansNeo/SpoqaHanSansNeo-Medium.ttf")
        format("truetype");
  }

  @font-face {
    font-family: "Spoqa Han Sans Neo";
    font-weight: 400;
    font-display: swap;
    src: local("Spoqa Han Sans Neo Regular"),
      url("/fonts/SpoqaHanSansNeo/SpoqaHanSansNeo-Regular.woff2")
        format("woff2"),
      url("/fonts/SpoqaHanSansNeo/SpoqaHanSansNeo-Regular.woff") format("woff"),
      url("/fonts/SpoqaHanSansNeo/SpoqaHanSansNeo-Regular.ttf")
        format("truetype");
  }

  @font-face {
    font-family: "Spoqa Han Sans Neo";
    font-weight: 300;
    font-display: swap;
    src: local("Spoqa Han Sans Neo Light"),
      url("/fonts/SpoqaHanSansNeo/SpoqaHanSansNeo-Light.woff2") format("woff2"),
      url("/fonts/SpoqaHanSansNeo/SpoqaHanSansNeo-Light.woff") format("woff"),
      url("/fonts/SpoqaHanSansNeo/SpoqaHanSansNeo-Light.ttf") format("truetype");
  }

  @font-face {
    font-family: "Spoqa Han Sans Neo";
    font-weight: 100;
    font-display: swap;
    src: local("Spoqa Han Sans Neo Thin"),
      url("/fonts/SpoqaHanSansNeo/SpoqaHanSansNeo-Thin.woff2") format("woff2"),
      url("/fonts/SpoqaHanSansNeo/SpoqaHanSansNeo-Thin.woff") format("woff"),
      url("/fonts/SpoqaHanSansNeo/SpoqaHanSansNeo-Thin.ttf") format("truetype");
  }

  /* noto-sans-kr-100 - korean */
  @font-face {
    font-family: "Noto Sans KR";
    font-style: normal;
    font-weight: 100;
    src: url("/fonts/NotoSansKR/noto-sans-kr-v13-korean-100.eot");
    src: local(""),
      url("/fonts/NotoSansKR/noto-sans-kr-v13-korean-100.eot?#iefix")
        format("embedded-opentype"),
      /* IE6-IE8 */ url("/fonts/NotoSansKR/noto-sans-kr-v13-korean-100.woff2")
        format("woff2"),
      /* Super Modern Browsers */
        url("/fonts/NotoSansKR/noto-sans-kr-v13-korean-100.woff") format("woff"),
      /* Modern Browsers */
        url("/fonts/NotoSansKR/noto-sans-kr-v13-korean-100.ttf")
        format("truetype"),
      /* Safari, Android, iOS */
        url("/fonts/NotoSansKR/noto-sans-kr-v13-korean-100.svg#NotoSansKR")
        format("svg"); /* Legacy iOS */
  }
  /* noto-sans-kr-300 - korean */
  @font-face {
    font-family: "Noto Sans KR";
    font-style: normal;
    font-weight: 300;
    src: url("/fonts/NotoSansKR/noto-sans-kr-v13-korean-300.eot"); /* IE9 Compat Modes */
    src: local(""),
      url("/fonts/NotoSansKR/noto-sans-kr-v13-korean-300.eot?#iefix")
        format("embedded-opentype"),
      /* IE6-IE8 */ url("/fonts/NotoSansKR/noto-sans-kr-v13-korean-300.woff2")
        format("woff2"),
      /* Super Modern Browsers */
        url("/fonts/NotoSansKR/noto-sans-kr-v13-korean-300.woff") format("woff"),
      /* Modern Browsers */
        url("/fonts/NotoSansKR/noto-sans-kr-v13-korean-300.ttf")
        format("truetype"),
      /* Safari, Android, iOS */
        url("/fonts/NotoSansKR/noto-sans-kr-v13-korean-300.svg#NotoSansKR")
        format("svg"); /* Legacy iOS */
  }
  /* noto-sans-kr-regular - korean */
  @font-face {
    font-family: "Noto Sans KR";
    font-style: normal;
    font-weight: 400;
    src: url("/fonts/NotoSansKR/noto-sans-kr-v13-korean-regular.eot"); /* IE9 Compat Modes */
    src: local(""),
      url("/fonts/NotoSansKR/noto-sans-kr-v13-korean-regular.eot?#iefix")
        format("embedded-opentype"),
      /* IE6-IE8 */
        url("/fonts/NotoSansKR/noto-sans-kr-v13-korean-regular.woff2")
        format("woff2"),
      /* Super Modern Browsers */
        url("/fonts/NotoSansKR/noto-sans-kr-v13-korean-regular.woff")
        format("woff"),
      /* Modern Browsers */
        url("/fonts/NotoSansKR/noto-sans-kr-v13-korean-regular.ttf")
        format("truetype"),
      /* Safari, Android, iOS */
        url("/fonts/NotoSansKR/noto-sans-kr-v13-korean-regular.svg#NotoSansKR")
        format("svg"); /* Legacy iOS */
  }
  /* noto-sans-kr-700 - korean */
  @font-face {
    font-family: "Noto Sans KR";
    font-style: normal;
    font-weight: 700;
    src: url("/fonts/NotoSansKR/noto-sans-kr-v13-korean-700.eot"); /* IE9 Compat Modes */
    src: local(""),
      url("/fonts/NotoSansKR/noto-sans-kr-v13-korean-700.eot?#iefix")
        format("embedded-opentype"),
      /* IE6-IE8 */ url("/fonts/NotoSansKR/noto-sans-kr-v13-korean-700.woff2")
        format("woff2"),
      /* Super Modern Browsers */
        url("/fonts/NotoSansKR/noto-sans-kr-v13-korean-700.woff") format("woff"),
      /* Modern Browsers */
        url("/fonts/NotoSansKR/noto-sans-kr-v13-korean-700.ttf")
        format("truetype"),
      /* Safari, Android, iOS */
        url("/fonts/NotoSansKR/noto-sans-kr-v13-korean-700.svg#NotoSansKR")
        format("svg"); /* Legacy iOS */
  }
  /* noto-sans-kr-500 - korean */
  @font-face {
    font-family: "Noto Sans KR";
    font-style: normal;
    font-weight: 500;
    src: url("/fonts/NotoSansKR/noto-sans-kr-v13-korean-500.eot"); /* IE9 Compat Modes */
    src: local(""),
      url("/fonts/NotoSansKR/noto-sans-kr-v13-korean-500.eot?#iefix")
        format("embedded-opentype"),
      /* IE6-IE8 */ url("/fonts/NotoSansKR/noto-sans-kr-v13-korean-500.woff2")
        format("woff2"),
      /* Super Modern Browsers */
        url("/fonts/NotoSansKR/noto-sans-kr-v13-korean-500.woff") format("woff"),
      /* Modern Browsers */
        url("/fonts/NotoSansKR/noto-sans-kr-v13-korean-500.ttf")
        format("truetype"),
      /* Safari, Android, iOS */
        url("/fonts/NotoSansKR/noto-sans-kr-v13-korean-500.svg#NotoSansKR")
        format("svg"); /* Legacy iOS */
  }
  /* noto-sans-kr-900 - korean */
  @font-face {
    font-family: "Noto Sans KR";
    font-style: normal;
    font-weight: 900;
    src: url("/fonts/NotoSansKR/noto-sans-kr-v13-korean-900.eot"); /* IE9 Compat Modes */
    src: local(""),
      url("/fonts/NotoSansKR/noto-sans-kr-v13-korean-900.eot?#iefix")
        format("embedded-opentype"),
      /* IE6-IE8 */ url("/fonts/NotoSansKR/noto-sans-kr-v13-korean-900.woff2")
        format("woff2"),
      /* Super Modern Browsers */
        url("/fonts/NotoSansKR/noto-sans-kr-v13-korean-900.woff") format("woff"),
      /* Modern Browsers */
        url("/fonts/NotoSansKR/noto-sans-kr-v13-korean-900.ttf")
        format("truetype"),
      /* Safari, Android, iOS */
        url("/fonts/NotoSansKR/noto-sans-kr-v13-korean-900.svg#NotoSansKR")
        format("svg"); /* Legacy iOS */
  }

  @font-face {
    font-family: "Roboto";
    src: url("/fonts/Roboto/roboto-thin-webfont.eot");
    src: url("/fonts/Roboto/roboto-thin-webfont.eot?#iefix")
        format("embedded-opentype"),
      url("/fonts/Roboto/roboto-thin-webfont.woff") format("woff"),
      url("/fonts/Roboto/roboto-thin-webfont.ttf") format("truetype");
    font-weight: 100;
    font-style: normal;
  }

  @font-face {
    font-family: "Roboto";
    src: url("/fonts/Roboto/roboto-thinitalic-webfont.eot");
    src: url("/fonts/Roboto/roboto-thinitalic-webfont.eot?#iefix")
        format("embedded-opentype"),
      url("/fonts/Roboto/roboto-thinitalic-webfont.woff") format("woff"),
      url("/fonts/Roboto/roboto-thinitalic-webfont.ttf") format("truetype");
    font-weight: 100;
    font-style: italic;
  }

  @font-face {
    font-family: "Roboto";
    src: url("/fonts/Roboto/roboto-light-webfont.eot");
    src: url("/fonts/Roboto/roboto-light-webfont.eot?#iefix")
        format("embedded-opentype"),
      url("/fonts/Roboto/roboto-light-webfont.woff") format("woff"),
      url("/fonts/Roboto/roboto-light-webfont.ttf") format("truetype");
    font-weight: 300;
    font-style: normal;
  }

  @font-face {
    font-family: "Roboto";
    src: url("/fonts/Roboto/roboto-lightitalic-webfont.eot");
    src: url("/fonts/Roboto/roboto-lightitalic-webfont.eot?#iefix")
        format("embedded-opentype"),
      url("/fonts/Roboto/roboto-lightitalic-webfont.woff") format("woff"),
      url("/fonts/Roboto/roboto-lightitalic-webfont.ttf") format("truetype");
    font-weight: 300;
    font-style: italic;
  }

  @font-face {
    font-family: "Roboto";
    src: url("/fonts/Roboto/roboto-regular-webfont.eot");
    src: url("/fonts/Roboto/roboto-regular-webfont.eot?#iefix")
        format("embedded-opentype"),
      url("/fonts/Roboto/roboto-regular-webfont.woff") format("woff"),
      url("/fonts/Roboto/roboto-regular-webfont.ttf") format("truetype");
    font-weight: 400;
    font-style: normal;
  }

  @font-face {
    font-family: "Roboto";
    src: url("/fonts/Roboto/roboto-italic-webfont.eot");
    src: url("/fonts/Roboto/roboto-italic-webfont.eot?#iefix")
        format("embedded-opentype"),
      url("/fonts/Roboto/roboto-italic-webfont.woff") format("woff"),
      url("/fonts/Roboto/roboto-italic-webfont.ttf") format("truetype");
    font-weight: 400;
    font-style: italic;
  }

  @font-face {
    font-family: "Roboto";
    src: url("/fonts/Roboto/roboto-medium-webfont.eot");
    src: url("/fonts/Roboto/roboto-medium-webfont.eot?#iefix")
        format("embedded-opentype"),
      url("/fonts/Roboto/roboto-medium-webfont.woff") format("woff"),
      url("/fonts/Roboto/roboto-medium-webfont.ttf") format("truetype");
    font-weight: 500;
    font-style: normal;
  }

  @font-face {
    font-family: "Roboto";
    src: url("/fonts/Roboto/roboto-mediumitalic-webfont.eot");
    src: url("/fonts/Roboto/roboto-mediumitalic-webfont.eot?#iefix")
        format("embedded-opentype"),
      url("/fonts/Roboto/roboto-mediumitalic-webfont.woff") format("woff"),
      url("/fonts/Roboto/roboto-mediumitalic-webfont.ttf") format("truetype");
    font-weight: 500;
    font-style: italic;
  }

  @font-face {
    font-family: "Roboto";
    src: url("/fonts/Roboto/roboto-bold-webfont.eot");
    src: url("/fonts/Roboto/roboto-bold-webfont.eot?#iefix")
        format("embedded-opentype"),
      url("/fonts/Roboto/roboto-bold-webfont.woff") format("woff"),
      url("/fonts/Roboto/roboto-bold-webfont.ttf") format("truetype");
    font-weight: 700;
    font-style: normal;
  }

  @font-face {
    font-family: "Roboto";
    src: url("/fonts/Roboto/roboto-bolditalic-webfont.eot");
    src: url("/fonts/Roboto/roboto-bolditalic-webfont.eot?#iefix")
        format("embedded-opentype"),
      url("/fonts/Roboto/roboto-bolditalic-webfont.woff") format("woff"),
      url("/fonts/Roboto/roboto-bolditalic-webfont.ttf") format("truetype");
    font-weight: 700;
    font-style: italic;
  }

  @font-face {
    font-family: "Roboto";
    src: url("/fonts/Roboto/roboto-black-webfont.eot");
    src: url("/fonts/Roboto/roboto-black-webfont.eot?#iefix")
        format("embedded-opentype"),
      url("/fonts/Roboto/roboto-black-webfont.woff") format("woff"),
      url("/fonts/Roboto/roboto-black-webfont.ttf") format("truetype");
    font-weight: 900;
    font-style: normal;
  }

  @font-face {
    font-family: "Roboto";
    src: url("/fonts/Roboto/roboto-blackitalic-webfont.eot");
    src: url("/fonts/Roboto/roboto-blackitalic-webfont.eot?#iefix")
        format("embedded-opentype"),
      url("/fonts/Roboto/roboto-blackitalic-webfont.woff") format("woff"),
      url("/fonts/Roboto/roboto-blackitalic-webfont.ttf") format("truetype");
    font-weight: 900;
    font-style: italic;
  }
`;
